document.addEventListener('DOMContentLoaded', function() {
  // Define mobile detection
  const isMobile = window.innerWidth < 768;
  
  // Elements
  const bundleItemsContainer = document.getElementById('bundle-items-container');
  const bundleSubtotalElement = document.getElementById('bundle-subtotal');
  const bundleDiscountElement = document.getElementById('bundle-discount');
  const bundleDiscountAmountElement = document.getElementById('bundle-discount-amount');
  const bundleTotalElement = document.getElementById('bundle-total');
  const addBundleButton = document.getElementById('add-bundle-to-cart');
  const emptyBundleMessage = document.querySelector('.empty-bundle-message');
  const bundleSidebar = document.querySelector('.bundle-sidebar');
  
  // Discount tiers
  const discountTiers = {
    2: 8,  // 2 products = 8% off
    3: 10, // 3 products = 10% off
    4: 15  // 4+ products = 15% off
  };
  
  // Bundle state
  let bundleItems = [];
  let bundleSubtotal = 0;
  let bundleDiscount = 0;
  let bundleTotal = 0;
  
  // Mobile UI setup
  if (isMobile && bundleSidebar) {
    // Create mobile bundle toggle button
    const toggleButton = document.createElement('button');
    toggleButton.className = 'bundle-mobile-toggle';
    toggleButton.innerHTML = 'View Bundle <span class="bundle-count">0</span>';
    document.querySelector('.bundle-builder-container').appendChild(toggleButton);
    
    // Hide sidebar by default on mobile
    bundleSidebar.classList.add('mobile-sidebar');
    
    // Add toggle functionality
    toggleButton.addEventListener('click', function(e) {
      e.preventDefault();
      bundleSidebar.classList.toggle('active');
    });
    
    // Close sidebar when clicking outside
    document.addEventListener('click', function(event) {
      if ((!bundleSidebar.contains(event.target) || event.target.classList.contains("bundle-close")) && event.target !== toggleButton && !toggleButton.contains(event.target) && !event.target.classList.contains("bundle-mobile-toggle") && !event.target.classList.contains("slider-button")) {
        bundleSidebar.classList.remove('active');
      }
    });
    
    // Add touchstart for mobile
    toggleButton.addEventListener('touchstart', function(e) {
      e.preventDefault();
      bundleSidebar.classList.toggle('active');
    }, {passive: false});
    
    // Update bundle count on toggle button
    const updateBundleCount = function() {
      const count = document.querySelectorAll('.bundle-item').length;
      document.querySelector('.bundle-count').textContent = count;
    };
    
    // Create a MutationObserver to watch for changes in the bundle items
    const observer = new MutationObserver(updateBundleCount);
    observer.observe(document.getElementById('bundle-items-container'), { childList: true });
  }
  
  // Add event listeners to all "Add to Bundle" buttons
  const addToBundleButtons = document.querySelectorAll('.add-to-bundle-btn');
  addToBundleButtons.forEach(button => {
    button.addEventListener('click', function() {
      const productId = this.getAttribute('data-product-id');
      const productCard = this.closest('.bundle-product-card');
      const variantSelect = productCard.querySelector('.variant-selector');
      
      // Handle products with only default variants
      if (!variantSelect) {
        // Get data directly from the button attributes
        const variantId = this.getAttribute('data-variant-id');
        const price = parseFloat(this.getAttribute('data-price'));
        const title = this.getAttribute('data-title');
        const image = this.getAttribute('data-image');
        
        addItemToBundle(productId, variantId, title, '', price, image);
      } else {
        // Handle products with multiple variants
        const variantId = variantSelect.value;
        const variantTitle = variantSelect.options[variantSelect.selectedIndex].text;
        const price = parseFloat(variantSelect.options[variantSelect.selectedIndex].getAttribute('data-price'));
        const title = this.getAttribute('data-title');
        const image = this.getAttribute('data-image');
        
        addItemToBundle(productId, variantId, title, variantTitle, price, image);
      }
    });
  });
  
  // Add option change listeners
const optionSelectors = document.querySelectorAll('.variant-option-selector');
optionSelectors.forEach(selector => {
  selector.addEventListener('change', function() {
    const productCard = this.closest('.bundle-product-card');
    const optionSelectors = productCard.querySelectorAll('.variant-option-selector');
    const variantSelector = productCard.querySelector('.variant-selector');
    const button = productCard.querySelector('.add-to-bundle-btn');
    
    // Get selected options
    const selectedOptions = [];
    optionSelectors.forEach(select => {
      selectedOptions.push(select.value);
    });
    
    // Find matching variant
    const variants = variantSelector.querySelectorAll('option');
    let matchingVariant = null;
    
    variants.forEach(variant => {
      let isMatch = true;
      for (let i = 0; i < selectedOptions.length; i++) {
        if (variant.getAttribute(`data-option${i+1}`) !== selectedOptions[i]) {
          isMatch = false;
          break;
        }
      }
      
      if (isMatch) {
        matchingVariant = variant;
        variantSelector.value = variant.value;
      }
    });
    
    if (matchingVariant) {
      const variantId = matchingVariant.value;
      const price = matchingVariant.getAttribute('data-price');
      const priceDisplay = productCard.querySelector('.bundle-product-price');
      const isAvailable = matchingVariant.getAttribute('data-available') === 'true';
      
      button.setAttribute('data-variant-id', variantId);
      button.setAttribute('data-price', price);

      // Update displayed price
      if (priceDisplay) {
        priceDisplay.textContent = formatMoney(price);
      }

      if (isAvailable) {
        button.textContent = 'Add to Bundle';
        button.disabled = false;
        button.classList.remove('out-of-stock');
      } else {
        button.textContent = 'Out of Stock';
        button.disabled = true;
        button.classList.add('out-of-stock');
      }
    }
  });
});

  
  // Add item to bundle
  function addItemToBundle(productId, variantId, title, variantTitle, price, image) {
    // Check if item already exists in bundle
    const existingItemIndex = bundleItems.findIndex(item => item.variantId === variantId);
    
    if (existingItemIndex >= 0) {
      // Increment quantity if item already exists
      bundleItems[existingItemIndex].quantity += 1;
      updateBundleItemQuantity(existingItemIndex);
    } else {
      // Add new item to bundle
      const newItem = {
        productId: productId,
        variantId: variantId,
        title: title,
        variantTitle: variantTitle !== 'Default Title' ? variantTitle : '',
        price: price,
        image: image,
        quantity: 1
      };
      
      bundleItems.push(newItem);
      renderBundleItem(newItem, bundleItems.length - 1);
    }
    
    updateBundleSummary();

      // After successfully adding the item, close the popup
  // Find and close the specific variant modal for this product
  const productCard = document.querySelector(`.bundle-product-card[data-product-id="${productId}"]`);
  if (productCard) {
    const variantModal = productCard.querySelector('.variant-pop-up');
    if (variantModal) {
      variantModal.style.display = 'none';
    }
  }
    
    // Create animation for added product on mobile
    if (isMobile) {
      const productCard = document.querySelector(`.bundle-product-card[data-product-id="${productId}"]`);
      if (productCard) {
        const productImage = productCard.querySelector('img').cloneNode(true);
        productImage.className = 'flying-product';
        document.body.appendChild(productImage);
        
        // Get positions
        const startRect = productCard.getBoundingClientRect();
        const endRect = document.querySelector('.bundle-mobile-toggle').getBoundingClientRect();
        
        // Set starting position
        productImage.style.top = `${startRect.top}px`;
        productImage.style.left = `${startRect.left}px`;
        productImage.style.width = `${startRect.width}px`;
        
        // Animate to cart
        setTimeout(() => {
          productImage.style.top = `${endRect.top}px`;
          productImage.style.left = `${endRect.left}px`;
          productImage.style.width = '30px';
          productImage.style.opacity = '0';
          
          // Remove element after animation
          setTimeout(() => {
            productImage.remove();
          }, 500);
        }, 10);
      }
    }
  }
  
  // Render a bundle item in the sidebar
  function renderBundleItem(item, index) {
    const itemElement = document.createElement('div');
    itemElement.className = 'bundle-item';
    itemElement.setAttribute('data-index', index);
    
    itemElement.innerHTML = `
      <div class="bundle-item-image">
        <img src="${item.image}" alt="${item.title}">
      </div>
      <div class="bundle-item-details">
        <h4>${item.title}</h4>
        ${item.variantTitle ? `<p class="bundle-item-variant">${item.variantTitle}</p>` : ''}
        <p class="bundle-item-price">${formatMoney(item.price)}</p>
        <div class="bundle-item-quantity">
          <button class="quantity-btn decrease">-</button>
          <span class="quantity-display">${item.quantity}</span>
          <button class="quantity-btn increase">+</button>
        </div>
      </div>
      <button class="remove-item-btn">&times;</button>
    `;
    
    // Add event listeners for quantity buttons and remove button
    const decreaseBtn = itemElement.querySelector('.decrease');
    const increaseBtn = itemElement.querySelector('.increase');
    const removeBtn = itemElement.querySelector('.remove-item-btn');
    
    decreaseBtn.addEventListener('click', function() {
      if (bundleItems[index].quantity > 1) {
        bundleItems[index].quantity -= 1;
        updateBundleItemQuantity(index);
        updateBundleSummary();
      }
    });
    
    increaseBtn.addEventListener('click', function() {
      bundleItems[index].quantity += 1;
      updateBundleItemQuantity(index);
      updateBundleSummary();
    });
    
    removeBtn.addEventListener('click', function() {
      bundleItems.splice(index, 1);
      updateBundleItemsIndexes();
      updateBundleSummary();
    });
    
    bundleItemsContainer.appendChild(itemElement);
    
    // Hide empty bundle message
    emptyBundleMessage.style.display = 'none';
  }
  
  // Update the quantity display for a bundle item
  function updateBundleItemQuantity(index) {
    const itemElement = document.querySelector(`.bundle-item[data-index="${index}"]`);
    if (itemElement) {
      const quantityDisplay = itemElement.querySelector('.quantity-display');
      quantityDisplay.textContent = bundleItems[index].quantity;
    }
  }
  
  // Update all bundle item indexes after removal
  function updateBundleItemsIndexes() {
    // Remove all items
    while (bundleItemsContainer.firstChild) {
      bundleItemsContainer.removeChild(bundleItemsContainer.firstChild);
    }
    
    // Re-render all items
    if (bundleItems.length > 0) {
      bundleItems.forEach((item, index) => {
        renderBundleItem(item, index);
      });
    } else {
      // Show empty bundle message
      emptyBundleMessage.style.display = 'block';
    }
  }
  
  // Update bundle summary (subtotal, discount, total)
  // Update the bundle summary calculation
function updateBundleSummary() {
  // Calculate total quantity of all items
  const totalQuantity = bundleItems.reduce((total, item) => total + item.quantity, 0);
  
  // Determine discount percentage based on total quantity
  let discountPercentage = 0;
  if (totalQuantity >= 4) {
    discountPercentage = 15;
  } else if (totalQuantity === 3) {
    discountPercentage = 10;
  } else if (totalQuantity === 2) {
    discountPercentage = 8;
  }

  // Calculate prices
  const subtotal = bundleItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const discount = subtotal * (discountPercentage / 100);
  const total = subtotal - discount;

  // Update UI
  bundleSubtotalElement.textContent = formatMoney(subtotal);
  bundleDiscountAmountElement.textContent = `-${formatMoney(discount)}`;
  bundleTotalElement.textContent = formatMoney(total);
  
  // Update discount message
  if (discountPercentage > 0) {
    bundleDiscountElement.textContent = `${discountPercentage}% Discount (${totalQuantity} items)`;
    bundleDiscountElement.style.display = 'block';
    bundleDiscountAmountElement.style.display = 'inline-flex';
    addBundleButton.disabled = false;
  } else {
    bundleDiscountElement.style.display = 'none';
    bundleDiscountAmountElement.style.display = 'none';
    addBundleButton.disabled = true;
  }
}

// Add this to your quantity button handlers
function updateItemQuantity(index, change) {
  bundleItems[index].quantity += change;
  if (bundleItems[index].quantity < 1) {
    bundleItems.splice(index, 1);
  }
  updateBundleItemsIndexes();
  updateBundleSummary(); // This will recalculate discount
}
  
  // Add bundle to cart - INTEGRATED WITH YOUR SLIDE CART
  addBundleButton.addEventListener('click', async function() {
    if (bundleItems.length === 0) {
      alert('Please add at least one product to your bundle.');
      return;
    }
    
    // Change button text
    addBundleButton.textContent = "ADDING...";
    addBundleButton.disabled = true;
    
    try {
      // Determine which discount code to apply based on number of unique products
      const uniqueProductCount = new Set(bundleItems.map(item => item.productId)).size;
      let discountCode = '';
      
      if (uniqueProductCount >= 4) {
        discountCode = 'BUNDLE4'; // 15% discount code for 4+ products
      } else if (uniqueProductCount === 3) {
        discountCode = 'BUNDLE3'; // 10% discount code for 3 products
      } else if (uniqueProductCount === 2) {
        discountCode = 'BUNDLE2';  // 8% discount code for 2 products
      }
      
      // Add items to cart one by one
      for (const item of bundleItems) {
        const formData = new FormData();
        formData.append('id', item.variantId);
        formData.append('quantity', item.quantity);
        formData.append('properties[_bundle_item]', 'true');
        
        await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
          headers: {
            'Accept': 'application/json'
          }
        });
      }
      
      // Apply discount code if applicable
      if (discountCode) {
        await applyDiscountToCart(discountCode).catch(error => {
          console.error('Error applying bundle discount:', error);
        });
      }
      
      // Update cart count in header (using your existing function)
      if (typeof updateHeaderCartCount === 'function') {
        await updateHeaderCartCount();
      }
      
      await refreshAndOpenCartDrawer();
      
      // Clear the bundle after adding to cart
      bundleItems = [];
      updateBundleItemsIndexes();
      updateBundleSummary();
      
    } catch (error) {
      console.error('Error adding bundle to cart:', error);
      alert('There was an error adding your bundle to cart. Please try again.');
    } finally {
      // Reset button text
      addBundleButton.textContent = "ADD BUNDLE TO BASKET";
      addBundleButton.disabled = false;
    }
  });

  async function refreshAndOpenCartDrawer() {
    const openDrawer = function() {
      if (typeof window.SLIDECART_OPEN === 'function') {
        window.SLIDECART_OPEN();
      } else if (typeof openSlideCart === 'function') {
        openSlideCart();
      }

      triggerCartLinkDrawer();
      setTimeout(updateSlideCartPrices, 500);
    };

    if (typeof window.SLIDECART_UPDATE === 'function') {
      const updateResult = window.SLIDECART_UPDATE();

      if (updateResult && typeof updateResult.then === 'function') {
        await updateResult.catch(error => {
          console.error('Error updating slide cart:', error);
        });
      }

      openDrawer();
      setTimeout(openDrawer, 500);

      return;
    }

    if (typeof updateSlideCart === 'function') {
      await updateSlideCart();
    }

    openDrawer();
  }

  function triggerCartLinkDrawer() {
    const cartLink = document.querySelector('a[href="/cart"], a[href="/cart/"]');

    if (!cartLink) return;

    cartLink.dispatchEvent(new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    }));
  }
  
  // Apply discount code to cart
  async function applyDiscountToCart(discountCode) {
    return new Promise((resolve, reject) => {
      const discountApplyUrl = `/discount/${discountCode}`;
      
      // Create hidden iframe to apply discount to session
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.onload = function() { 
        iframe.parentNode.removeChild(iframe);
        resolve();
      };
      iframe.onerror = function() {
        iframe.parentNode.removeChild(iframe);
        reject(new Error('Failed to apply discount'));
      };
      iframe.src = discountApplyUrl;
      document.body.appendChild(iframe);
    });
  }
  
  // Update slide cart prices
  function updateSlideCartPrices() {
    const cartItems = document.querySelectorAll('.slide-cart-item');
    const bundleItemsCount = new Set(Array.from(cartItems).filter(item => item.querySelector('[data-property-name="_bundle_item"]')).map(item => item.getAttribute('data-variant-id'))).size;
    
    cartItems.forEach(item => {
      // Check if this is a bundle item by looking for the hidden property
      const isBundleItem = item.querySelector('[data-property-name="_bundle_item"]');
      
      if (isBundleItem) {
        // Get the price elements
        const priceContainer = item.querySelector('.slide-cart-line-item-price-container');
        const priceElement = item.querySelector('#slide-cart-line-item-price');
        
        if (priceContainer && priceElement) {
          // Get current price
          const currentPrice = parseFloat(priceElement.textContent.replace(/[^0-9.-]+/g, ''));
          
          // Determine which discount to apply based on how many unique variants are in the bundle
          let discountPercentage = 0;
          
          if (bundleItemsCount >= 4) {
            discountPercentage = 15;
          } else if (bundleItemsCount === 3) {
            discountPercentage = 10;
          } else if (bundleItemsCount === 2) {
            discountPercentage = 8;
          }
          
          if (discountPercentage > 0) {
            // Calculate original price
            const originalPrice = currentPrice / (1 - (discountPercentage / 100));
            
            // Create and insert original price strikethrough
            const originalPriceElement = document.createElement('s');
            originalPriceElement.className = 'slide-cart-original-price';
            originalPriceElement.textContent = formatMoney(originalPrice);
            
            // Add discount class to current price
            priceElement.classList.add('slide-cart-discounted-price');
            
            // Insert original price before current price
            priceContainer.insertBefore(originalPriceElement, priceElement);
          }
        }
      }
    });
  }
  
  // Format money values based on Shopify's money format
 function formatMoney(cents) {
  // Ensure cents is a number
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  cents = parseInt(cents, 10);

  // Define the USD money format
  const usdFormat = '${{amount}}';

  // Format the money value
  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) return '0';
    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
    const cents = parts[1] ? `${decimal}${parts[1]}` : '';

    return dollars + cents;
  }

  // Replace the placeholder in the format with the formatted value
  return usdFormat.replace('{{amount}}', formatWithDelimiters(cents));
}

});
